import { BaseContainerModel } from '../base-container.model';
import { bl_wms_container_space_scan_session_hdr_queue_RowClass, bl_wms_container_space_scan_session_hdr_queue_RowInterface } from '../../dbschema/index';

export class WmsContainerSpaceScanSessionHdrQueueContainer extends BaseContainerModel {
    bl_wms_container_space_scan_session_hdr_queue: bl_wms_container_space_scan_session_hdr_queue_RowInterface = new bl_wms_container_space_scan_session_hdr_queue_RowClass();
}
